// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps

const Importcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon width="48" height="48" viewBox="0 0 48 48" fill="none" {...props}>
      <g opacity="0.16">
        <path d="M23.2191 35.0239C23.6195 35.5243 24.3805 35.5243 24.7809 35.0239L30.7002 27.6247C31.2241 26.9699 30.7579 26 29.9194 26H26V6C26 4.89543 25.1046 4 24 4C22.8954 4 22 4.89543 22 6V26H18.0806C17.2421 26 16.7759 26.9699 17.2998 27.6247L23.2191 35.0239Z" fill="#0870d8" />
        <path d="M38 18H32C30.8954 18 30 18.8954 30 20C30 21.1046 30.8954 22 32 22H38V40H10V22H16C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18H10C7.794 18 6 19.794 6 22V40C6 42.206 7.794 44 10 44H38C40.206 44 42 42.206 42 40V22C42 19.794 40.206 18 38 18Z" fill="#0870d8" />
      </g>
    </SvgIcon>
  );
};

export default Importcon;